const setFirstAndThirdBits = (num: number) => {

	const mask = 0b101;
	const result = num | mask;
	
	return result;
};

export default setFirstAndThirdBits;
